(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["chiffon-customer-reviews"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('chiffon-customer-reviews')) {
  customElements.define('chiffon-customer-reviews', class extends HTMLElement {
    connectedCallback() {
      if (this.reviewClickHandler) return;
      this.reviewClickHandler = event => {
        const openButton = event.target.closest('[data-review-open]');
        if (openButton && this.contains(openButton)) {
          const dialog = document.getElementById(openButton.dataset.reviewOpen);
          if (dialog && this.contains(dialog)) dialog.showModal();
          return;
        }
        const toggle = event.target.closest('[data-review-toggle]');
        if (toggle && this.contains(toggle)) {
          const expanded = toggle.getAttribute('aria-expanded') !== 'true';
          this.querySelectorAll('[data-extra-review]').forEach(card => { card.hidden = !expanded; });
          toggle.setAttribute('aria-expanded', String(expanded));
          toggle.textContent = expanded ? toggle.dataset.less : toggle.dataset.more;
          return;
        }
        if (event.target.tagName === 'DIALOG') {
          const dialog = event.target;
          const bounds = dialog.getBoundingClientRect();
          if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
        }
      };
      this.addEventListener('click', this.reviewClickHandler);
    }
    disconnectedCallback() {
      this.removeEventListener('click', this.reviewClickHandler);
      this.reviewClickHandler = null;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();
})();
